export default __webpack_public_path__ + "static/media/screen_google_calendar_09.9d167e4e.png";